import { render } from "./PatientsDatatableTDPaymentVisit.vue?vue&type=template&id=74f76b14"
import script from "./PatientsDatatableTDPaymentVisit.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableTDPaymentVisit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__